import PropTypes from 'prop-types';
import { USER_ROLES } from './constants';

export const UserRolesPropType = PropTypes.oneOf(Object.values(USER_ROLES).map((role) => role.value));

export default { UserRolesPropType };
